<template>
  <div>
    <template>
      <v-stepper v-model="e1">
        <v-stepper-header v-show="e1 > 1">
          <v-stepper-step :complete="e1 > 1" step="1">
            Contact Information
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2">
            Create Account
          </v-stepper-step>

          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <div v-if="buyer == true" class="card z-depth-3 pb-4 border-none">
              <div>
                <img
                  class="w-full object-cover"
                  src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                  alt="homesby360"
                />
              </div>
              <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
                  <div class="flex">
                    <img
                      class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                      src="../assets/Nicola.png"
                      alt="RealtorImage"
                    />

                    <div class="mt-12 sm:mt-16 ml-4">
                      <h1 class="text-2xl font-bold text-gray-700 truncate">
                        Nicola Burger (Broker in Charge)<br />
                        <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                  <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                  Watch Intro
                                </button> -->
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <p
                class="mt-2 font-weight-light mx-auto text-xl text-center text-gray-500"
              >
                <span class="uppercase text-4xl"> Welcome</span> <br />
                Our team is excited to work with you! Please provide us with
                your contact information and a team member will contact you
                shortly!
              </p>
            </div>

            <div v-else>
              <div>
                <img
                  class="max-w-4xl object-cover"
                  src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                  alt="homesby360"
                />
              </div>
              <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
                  <div class="flex">
                    <img
                      class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                      src="../assets/Nicola.png"
                      alt="RealtorImage"
                    />

                    <div class="mt-12 sm:mt-16 ml-4">
                      <h1 class="text-2xl font-bold text-gray-700 truncate">
                        Nicola Burger (Broker in Charge) <br />
                        <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                  <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                  Watch Intro
                                </button> -->
                      </h1>
                    </div>
                  </div>
                </div>

                <p
                  class="mt-2 font-weight-light mx-auto text-xl text-center text-gray-500"
                >
                  <span class="uppercase text-4xl">
                    Create your free account</span
                  >
                  <br />
                  <span class="textarea w-75"
                    >Find your dream home and submit an offer faster with your
                    account</span
                  >
                </p>
              </div>
            </div>

            <v-card-text>
              <v-form v-model="valid" @submit.prevent="createCRM()">
                <div class="container">
                  <div class="form-group">
                    <v-text-field
                      v-model="name"
                      :rules="firstRules"
                      :counter="20"
                      label="Name"
                      required
                    ></v-text-field>
                  </div>

                  <div class="form-group">
                    <v-text-field
                      v-model="phone"
                      :rules="phoneRules"
                      :counter="12"
                      label="Phone"
                      required
                    ></v-text-field>
                  </div>

                  <div class="form-group">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                  </div>

                  <v-btn
                    @click="createCRM()"
                    :disabled="name === '' || phone === '' || email === ''"
                    color="primary"
                  >
                    Send
                  </v-btn>
                  <v-btn @click="closing()" text> Skip</v-btn>
                  <!-- <v-btn v-if="buyer == true" @click="closing()" text>
                    Skip</v-btn
                  > -->
                  <v-btn @click="closeModal()" text> Cancel</v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-stepper-content>

          <v-stepper-content step="2">
            <h2
              class="text-2xl font-extrabold tracking-tight text-gray-900 uppercase sm:text-3xl mb-4 text-center"
            >
              Create your account for the best service!
            </h2>

            <div class="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
              <div class="bg-gray-50 sm:px-6 lg:col-span-2 p-4">
                <div class="max-w-lg">
                  <p class="text-center text-lg leading-6 text-gray-500">
                    With your account
                  </p>

                  <div class="flow-root">
                    <ul class="-mb-8">
                      <li v-for="item in items" :key="item">
                        <div class="relative pb-8">
                          <span
                            class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200 last:bg-gray-50"
                            aria-hidden="true"
                          ></span>
                          <div class="relative flex space-x-3">
                            <div>
                              <span
                                class="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white"
                              >
                                <!-- Heroicon name: solid/thumb-up -->
                                <svg
                                  class="h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div
                              class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4"
                            >
                              <div>
                                <p class="text-sm text-gray-500">{{ item }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div class="relative pb-8">
                          <div class="relative flex space-x-3">
                            <div>
                              <span
                                class="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white"
                              >
                                <!-- Heroicon name: solid/thumb-up -->
                                <svg
                                  class="h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div
                              class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4"
                            >
                              <div>
                                <p class="text-sm text-gray-500">
                                  Submit offer to purchase all from one account
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div
                    v-if="unlockMessage"
                    class="mt-8 bg-green-100 p-4 rounded-full"
                  >
                    <h2
                      class="text-2xl text-center font-bold tracking-tight text-gray-900"
                    >
                      Provide contact information to unlock more search
                      capabilities!
                    </h2>
                  </div>
                </div>
              </div>
              <div class="bg-white px-4 sm:px-6 lg:col-span-3 lg:px-8 xl:pl-12">
                <div class="max-w-lg mx-auto lg:max-w-none">
                  <ul>
                    <li
                      class="col-span-1 flex flex-col text-center divide-y divide-gray-200"
                    >
                      <div class="flex-1 flex flex-col p-8">
                        <span
                          class="w-32 h-32 flex-shrink-0 mx-auto rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                        >
                          <!-- Heroicon name: solid/user -->
                          <svg
                            class="h-20 w-20 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </span>

                        <h3 class="mt-6 text-gray-900 text-sm font-medium">
                          {{ name }}
                        </h3>
                        <dl
                          class="mt-1 flex-grow flex flex-col justify-between"
                        >
                          <dd class="text-gray-500 text-sm">{{ phone }}</dd>
                          <dd class="mt-3">
                            <span
                              class="px-2 py-1 text-blue-800 text-xs font-medium bg-blue-100 rounded-full"
                              >{{ email }}</span
                            >
                          </dd>
                        </dl>
                      </div>
                      <div>
                        <div v-if="buyer == true" class="-mt-px p-4">
                          <button
                            @click="register(email)"
                            type="button"
                            class="uppercase inline-flex items-center px-3.5 py-2 text-xl leading-4 font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Create my free account
                          </button>
                        </div>

                        <div v-else>
                          <button
                            @click="register(email)"
                            type="button"
                            class="uppercase inline-flex items-center px-3.5 py-2 text-sm leading-4 font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Create my free account
                          </button>
                          <br />

                          <a
                            @click="closing()"
                            class="mt-2 cursor-pointer relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-500 font-medium hover:text-gray-500"
                          >
                            <span class="ml-3">Continue</span>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["unlockMessage", "source", "buyer"],
  data() {
    return {
      items: [
        "Access robust search features",
        "Get auto alerted when properties meeting your criteria become available",
        "Side by side comparisons of your favorite properties"
      ],
      valid: true,
      e1: 1,
      name: "",
      email: "",
      phone: "",

      firstRules: [
        v => !!v || "Fist name is required",
        v =>
          (v && v.length <= 20) || "Fist name must be less than 15 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ]
    };
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    createCRM() {
      let tag = new FormData();

      tag.append("name", this.name);
      tag.append("email", this.email);
      tag.append("phone", this.phone);
      tag.append("source", this.source);

      window.axios.post("/api/newContact", tag).then(res => {
        if (res.data === "exists") {
          Swal.fire({
            icon: "error",
            title: "Duplicate Email",
            text:
              "This email is already register as a contact please try another"
          });
        } else {
          if (this.buyer == true) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Contact succesfully sent",
              showConfirmButton: false,
              timer: 1500
            });
            sessionStorage.setItem("modal", true);
            this.$emit("event");
          } else {
            this.e1 = 2;
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Contact succesfully sent",
              showConfirmButton: false,
              timer: 1500
            });
            sessionStorage.setItem("modal", true);

            fetch("https://api.ipify.org?format=json")
              .then(x => x.json())
              .then(({ ip }) => {
                setTimeout(() => {
                  window.axios
                    .post("api/geoRent", { rawIp: ip, tagId: 1 })
                    .then(res => {
                      console.log(res.data);
                    });
                }, 2000);
              });
          }
        }
      });
    },

    sendMessage() {
      window.axios.post("/api/messages", this.contact).then(() => {
        this.contact = {};
        alert("Message Sent");
        sessionStorage.setItem("modal", true);
        location.reload();
      });
    },

    closing() {
      //sessionStorage.setItem("modal", true);
      this.$emit("event");
      //location.reload()
    },

    register(email) {
      window.axios
        .post("/api/createUser", {
          email: email
        })
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "User succesfully created",
            showConfirmButton: false,
            timer: 1500
          });
          this.$router.push({ name: "VerifyMessage" });
          // this.$emit("event");
        });
    }
  }
};
</script>

<style>
#challange-target {
  display: none;
}

@media (max-width: 1026px) {
  #challange-target {
    display: block;
    margin-top: 65px;
    color: transparent;
  }
}
</style>
